// extracted by mini-css-extract-plugin
export var closeButton = "_3v-3";
export var header = "_3v-0";
export var link = "_3v-1";
export var retryButton = "_3v-2";